import _ from "lodash";
import {
  useGetPickUpDelayQuery,
} from "../../redux/commonRTK";
import {
  getCourierParentById,
  formatDate,
  timeIsGrater,
  parseDate,
} from "../../helpers/UtilityHelper";
import { addDays } from "date-fns";

export default function usePickupDelay(merchantID, shipmentType = 'B2C') {
  let rawDelayData = useGetPickUpDelayQuery({'merchant':merchantID,'shipment_type': shipmentType, 'order_type': 'FORWARD'});
  // let rawPickedData = useGetPickedUpQuery({'merchant':merchantID,'shipment_type': "B2C"});

  if (
    rawDelayData.isLoading ||
    rawDelayData.isFetching 
  ) {
    return { isCalculating: true };
  }

  let filterDelayData = [];
  let k = rawDelayData?.data?.data.filter((item, index) => {
    return (item._id?.orderType==='FORWARD SHIPMENT' && item._id.isBreached===true);
  });
  k?.filter((item, index) => {
    item.data.filter((e) =>
      filterDelayData.push({ ...e, courierID: item?._id?.courier })
    );
  });

  const pickUpDelayed = _(filterDelayData || [])
    .transform(function (result, item) {
      const createdHis = item.awbRegisteredDate;
      const failedPickup = item.pickupFailedCount;

      if (createdHis) {
        const createdDate = parseDate(createdHis);
        const createdTime = formatDate(createdDate, "HH:mm");
        const isCreatedAfter12 = timeIsGrater(createdTime, "12:00");

        let estPickupDate;
        if (isCreatedAfter12) {
          estPickupDate = addDays(parseDate(item.estimatedPickupDate), 1);
        } else {
          estPickupDate = parseDate(item.estimatedPickupDate);
        }

        let pickupDelayInDays = item.pickupBreachedAgeingDays;
        let pickupDelayText = `${item.pickupBreachedAgeingDays} days`;

        let pickupDelayLabel;
        if (pickupDelayInDays === 0) {
          pickupDelayLabel = "On Time";
        } else if (pickupDelayInDays < 3) {
          pickupDelayLabel = `+${pickupDelayInDays} Day`;
        } else {
          pickupDelayLabel = "3+ Day";
        }

        const courierName = getCourierParentById(item.courierID);
        result.push({
          ...item,
          order_date: createdHis,
          pickupDelayText,
          pickupDelayInDays,
          courierName,
          pickupDelayLabel,
          estPickupDate,
          failedPickup: failedPickup,
        });
      }
    })
    // Count only pickups actually overdue (breach ageing > 0), matching the
    // forward-delay definition so Total Alerts is consistent across all three buckets.
    .filter(function (item) {
      return item.pickupDelayInDays > 0;
    })
    .value();

  return { pickUpDelayed };
}
